import { z } from 'zod';
/**
 * Traslado del caso a otra área. Reasignar (cambiar de responsable) es del líder del área y del Administrador; trasladar
 * de área lo pide quien responde el caso y lo aprueba quien aprueba en el área de origen. El líder y el Administrador
 * trasladan directo. Al trasladarse, el reparto automático elige al responsable en el área nueva.
 */
export const AreaTransferStatus = { PENDING: 'PENDING', APPROVED: 'APPROVED', REJECTED: 'REJECTED', CANCELLED: 'CANCELLED' };
export const AREA_TRANSFER_STATUS_LABEL = { PENDING: 'Pendiente', APPROVED: 'Aprobado', REJECTED: 'Rechazado', CANCELLED: 'Cancelado' };
export const createAreaTransferSchema = z.object({
    toUnitId: z.string().uuid('Elige el área'),
    reason: z.string().trim().min(10, 'Explica por qué el caso es de esa área (al menos 10 caracteres)').max(2000),
});
/** Rechazar pide el motivo (llega a quien lo pidió); aprobar, no. */
export const decideAreaTransferSchema = z.object({
    approve: z.boolean(),
    comment: z.string().trim().max(2000).optional(),
}).refine((v) => v.approve || (v.comment?.length ?? 0) >= 3, { message: 'Escribe por qué se rechaza', path: ['comment'] });
export const cancelAreaTransferSchema = z.object({ reason: z.string().trim().min(3, 'Escribe el motivo').max(500) });
//# sourceMappingURL=area-transfer.js.map